import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import mask from "./common/plugins/mask.js";
import ApiService from "./common/services/http/api.service";
import { VERIFY_AUTH } from "./store/auth.module";
import VueAzureUploader from "vue-azure-blob-upload";
Vue.use(VueAzureUploader);
Vue.config.productionTip = false;

// Global 3rd party plugins
import "bootstrap";
import "popper.js";
import "tooltip.js";
import "perfect-scrollbar";
import "./common/plugins/mask";
import "./common/plugins/vue-json-excel";
import "./common/plugins/vue-pdf-app";

// Vue 3rd party plugins
import i18n from "./common/plugins/vue-i18n";
import vuetify from "./common/plugins/vuetify";
import "./common/plugins/bootstrap-vue";
import "./common/plugins/perfect-scrollbar";
import "./common/plugins/highlight-js";
import "@babel/polyfill";
import "@mdi/font/css/materialdesignicons.css";

// API service init
ApiService.init();

// Ensure we checked auth before each page load.
router.beforeEach((to, from, next) => {
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  mask,
  render: (h) => h(App),
}).$mount("#app");
